// Grille tarifaire officielle Académie AETHERIS — source unique pour Home, Services et pages d'offre.
export const CALENDLY_URL = "https://calendly.com/r-cassilde";
export const STRIPE_ANALYSE_URL = "https://buy.stripe.com/6oU4gz4lagPQ5MU67Z0sU0h";
export const STRIPE_PACK_URL = "https://buy.stripe.com/eVqcN5dVKgPQ6QY2VN0sU0g";

export const OFFERS = [
  {
    slug: "diagnostic_inaugural",
    name: "Diagnostic Inaugural",
    price: "Gratuit",
    note: "Première lecture",
    to: "/diagnostic-inaugural",
    ctaLabel: "Obtenir mon Diagnostic Inaugural — Gratuit",
    desc: "Vos deux nombres fondateurs — Chemin de Vie et Kua — calculés instantanément, puis une lecture détaillée par email. La porte d'entrée de la Triple Fusion™.",
    points: ["Chemin de Vie et Kua Lo Shu", "Lecture détaillée par email", "Sans engagement"],
  },
  {
    slug: "analyse_precision",
    name: "Analyse de Précision Triple Fusion™",
    price: "149 €",
    note: "PDF personnalisé sous 48 h",
    to: "/analyse-de-precision",
    href: STRIPE_ANALYSE_URL,
    ctaLabel: "Commander mon Analyse — 149 €",
    desc: "Votre architecture intérieure lue par la Triple Fusion™ : un document écrit, individuel, livré en PDF sous 48 h. Garantie 30 jours remboursement.",
    points: ["Chemin de Vie pythagoricien expliqué", "Équilibres de votre profil Lo Shu", "Perspective stratégique liée à votre question", "Garantie 30 jours remboursement"],
  },
  {
    slug: "pack_renaissance",
    name: "Pack Renaissance Quantique",
    price: "250 €",
    note: "4 rendez-vous individuels",
    href: STRIPE_PACK_URL,
    ctaLabel: "Réserver mon Pack — 250 €",
    featured: true,
    desc: "Quatre rendez-vous de coaching individuel pour transformer votre lecture en décisions et lever les premiers verrous.",
    points: ["4 rendez-vous individuels", "Travail sur vos verrous prioritaires", "Plan d'action souverain"],
  },
  {
    slug: "coaching_elite",
    name: "Coaching Élite",
    price: "1 950 €",
    note: "12 rendez-vous · 3 mois",
    to: "/coaching-elite",
    href: CALENDLY_URL,
    ctaLabel: "Réserver mon rendez-vous découverte",
    desc: "Douze rendez-vous individuels sur trois mois avec Rodrigue CASSILDÉ : décodage, cartographie, réalignement et ancrage de votre Architecture de Vie.",
    points: ["12 rendez-vous individuels", "Lecture Triple Fusion™ complète", "Accès direct à Rodrigue CASSILDÉ"],
  },
  {
    slug: "coaching_souverain",
    name: "Coaching Souverain",
    price: "3 500 €",
    note: "24 rendez-vous · 6 mois",
    to: "/coaching-souverain",
    href: CALENDLY_URL,
    ctaLabel: "Réserver mon rendez-vous découverte",
    desc: "L'engagement le plus profond de l'Académie : vingt-quatre rendez-vous sur six mois pour une refondation complète — personne, lignée, territoire et mission.",
    points: ["24 rendez-vous individuels", "Suivi continu sur 6 mois", "Accès prioritaire au Cercle privé"],
  },
];
